jQuery(function($){
  'use strict';

  $.fn.scrolly = function(options) {

    var $elem = this.eq(0);

    var settings = $.extend({
      auto : true,              // Automatically make anchor links use scrolly
      hashbang : true,          // Register scrolly for hashbang in URLs
      exclude : ".no-scrolly",  // Do not register scrolly for links with this selector.
      topOffset : 0,            // Adds an offset (in px) to the top of the scroll, good when you have a fixed element at the top
      anchorOffset : 20         // Adds some extra room to the scroll destination
    },options);

    $elem.each(function(){

      $.easing.easeInQuint = function (x, t, b, c, d) {
        return c*(t/=d)*t*t*t*t + b;
      };

      var z=$elem.offset().top - settings.anchorOffset - settings.topOffset;
      $("html, body").animate({"scrollTop":z+"px"},{"duration":750,easing:"easeInQuint"});

    });

    return this;
  };
});